<script>
import { priceFormatter } from "@/utils/formatter.js";

export default {
  name: "formInputNumber",
  components: {},
  props: {
    //值
    value: {
      type: [String, Number],
      default: () => ""
    },
    //标题
    title: {
      type: String,
      default: ""
    },
    //标题宽度
    titleWidth: {
      type: String,
      default: ""
    },
    //提示
    placeholder: {
      type: String,
      default: "请输入"
    },
    //必填
    required: {
      type: Boolean,
      default: false
    },
    //只读
    readonly: {
      type: Boolean,
      default: false
    },
    //禁用
    disabled: {
      type: Boolean,
      default: false
    },
    //小数位数
    digit: {
      type: Number,
      default: 2
    },
    //是否允许负数
    negative: {
      type: Boolean,
      default: false
    },
    //是否启用清除图标
    clearable: {
      type: Boolean,
      default: false
    },
    //最小
    min: {
      type: Number,
      default: null
    },
    //最大
    max: {
      type: Number,
      default: null
    },
    //focus时  选中所有输入值
    focusSelectAll: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      realValue: this.value
    };
  },
  watch: {
    realValue(e) {
      if (this.realValue != this.value) {
        this.$emit("input", e);
      }
    },
    value(e) {
      if (this.realValue != this.value) {
        this.realValue = e;
      }
    }
  },
  created() {},
  methods: {
    /**
     * @description: 获取值
     * @param {*}
     * @return {*}
     */
    getValue() {
      return this.realValue;
    },
    /**
     * @description: 赋值
     * @param {*}
     * @return {*}
     */
    setValue(e) {
      this.realValue = e;
    }
  },
  render() {
    let { readonly, disabled, max, min } = this;
    readonly = readonly || disabled;
    const option = {
      props: {
        readonly,
        disabled,
        label: this.title,
        labelWidth: this.titleWidth,
        required: this.required,
        clearable: this.clearable,
        value: this.realValue
      },
      ref: "input"
    };
    if (!readonly) {
      option.props.placeholder = this.placeholder;
      option.props.formatter = e => {
        e = priceFormatter(e, {
          digit: this.digit,
          negative: this.negative
        });
        if (min !== null && e < min) {
          e = min;
        }
        if (max !== null && e > max) {
          e = max;
        }
        return e;
      };
      let listeners = {};
      for (const key in this.$listeners) {
        listeners[key] = (...arg) => {
          this.$emit(key, ...arg);
        };
      }
      option.on = {
        ...listeners,
        focus: e => {
          if (this.focusSelectAll) {
            this.$refs.input.$refs.input.select();
          }
          this.$emit("focus", e);
        },
        input: e => {
          this.realValue = e;
          this.$emit("change", e);
        }
      };
    }
    if (this.$scopedSlots) {
      option.scopedSlots = this.$scopedSlots;
    }
    return <van-field {...option} />;
  }
};
</script>

<style lang="less" scoped></style>
